import axios from "axios"
import { payload, anonymus } from "../../utils/auth"
import { API_URI } from "../../config/API_URI"

export const authAPIToken = (username: string, password: string) => {
    return new Promise((resolve, reject) => {
        axios
            .post(
                `${API_URI}api-token-auth/`,
                {},
                {auth: {
                    username: username ? username : "",
                    password: password ? password : ""
                }}
            )
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}

export const getCurrentUser = (token: string) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${API_URI}user/`, payload(token))
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}

export const updateContactInfoUser = (values: any, token: string) => {
    return new Promise((resolve, reject) => {
        axios
            .put(`${API_URI}user/`, values, payload(token))
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}

export const addAddressUser = (address: any, contactInfo: any, token: string) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${API_URI}address_book/`, {
                first_name: contactInfo?.name,
                last_name: contactInfo?.surname,
                street_address: address?.address_1,
                flat_number: address?.flat_number,
                floor: address?.floor,
                gate_code: address?.gate_code,
                postal_code: address?.postcode,
                city: address?.city,
                country: address?.country,
                additional_info: address?.additional_info,
                phone_number: contactInfo?.phoneNumber || "",
                email: contactInfo?.email,
                invoice: {
                    company_name: address?.invoice?.company_name,
                    first_name: contactInfo?.name,
                    last_name: contactInfo?.surname,
                    street_address: address?.invoice?.address_1,
                    city: address?.invoice?.city,
                    postal_code: address?.invoice?.postcode,
                    NIP: address?.invoice?.NIP
                }
            }, token ? payload(token) : anonymus())
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}

export const addAddressToUserBook = (address: any, email: string, phone: string, token: string) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${API_URI}address_book/`, {
                first_name: address?.first_name,
                last_name: address?.last_name,
                street_address: address?.address_1,
                flat_number: address?.flat_number,
                floor: address?.floor,
                gate_code: address?.gate_code,
                postal_code: address?.postcode,
                city: address?.city,
                country: address?.country,
                additional_info: address?.additional_info,
                phone_number: phone || "",
                email: email,
                invoice: {
                    company_name: address?.invoice?.company_name,
                    first_name: address?.invoice?.first_name,
                    last_name: address?.invoice?.last_name,
                    street_address: address?.invoice?.address_1,
                    city: address?.invoice?.city,
                    postal_code: address?.invoice?.postcode,
                    NIP: address?.invoice?.NIP
                }
            }, token ? payload(token) : anonymus())
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}

export const getAddressUser = (token: string) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${API_URI}address_book/`, token ? payload(token) : anonymus())
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}

export const deleteAddressUser = (id: number, token: string) => {
    const data = {
        data: {
            id: id
        }
    }
    return new Promise((resolve, reject) => {
        axios
            .delete(`${API_URI}address_book/`, {...payload(token), ...data})
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}

export const deleteAccountUser = (token: string) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(`${API_URI}user/`, payload(token))
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}